<div class="content">
  <div class="content">
   <div class="container-fluid" >
   <div class="row">
   <div class="col-lg-12 col-md-12 col-sm-12 common_title">
   <h2>STOCK LEVEL DATABASE</h2>
   <!--<p>Cumulative and Annual Calculation List</p>-->
    <a [routerLink]="['/dashboard','Reportmanagement']" class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i> Back</a>
   </div>
   </div>
   <div class="row" >
     
    <div class="col-lg-2 col-sm-2 col-12" style="margin-top: 20px;" >
    
      <form enctype="application/x-www-form-urlencoded" role="form" autocomplete="off" >
        <fieldset>
          <date-range-picker [options]="" [controlName]="'rightDateRange'" aria-readonly="true"></date-range-picker>
        </fieldset>
      </form>
     
     </div>
   <div class="col-lg-2 col-md-2 col-sm-12">
      <div class="form-group multiple">
      <label for="Species Name">Farm Name</label>
      <select  name="farmname" id="farmname" class="form-control selectpicker myFakeClass" >
        <option *ngFor='let farmlist of getfarmsListData' [value]="farmlist.tnfr_id">{{farmlist.tnfr_name}}</option>
      </select>
      </div>
      </div>
    <div class="col-lg-2 col-md-2 col-sm-12">
        <div class="form-group">
        <label for="Species Name">Species Name</label>
        <select id="Speciesname" class="selectpicker form-control myFakeClass1" (change)="breedselectbyspecies($event)">
          <option *ngFor='let specieslist of speciesloaddata' [value]="specieslist.id">{{specieslist.name}}</option>
        </select>
        </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-12">
          <div class="form-group">
          <label for="Breed Name">Breed Name</label>
          <select id="BreedName" class="selectpicker form-control myFakeClass2">
            <option *ngFor='let breedname of getspeciesvalue' [value]="breedname.id">{{breedname.name}}</option>
          </select>
          </div>
          </div>
          <div class="col-lg-2 col-sm-3 col-12" >
            <div class="form-group">
               <label for="Breed Name">Age</label>
               <select id="age" class="selectpicker form-control myFakeClass3" >
                <option *ngFor='let age_data of get_age' [value]="age_data.tnag_id">{{age_data.tnag_name}}({{age_data.tnag_time_range}}) </option>
              </select>
            </div>
           </div>
           <div class="col-lg-1 col-sm-3 col-12">
            <div class="form-group">
              <label for="Breed Name"></label>
               <span class="input-group-btn">
                   <button class="btn btn-primary search" type="button" (click)="get_datas()" ><span class="fa fa-search"></span> Search</button>
               </span>
              </div>
              
        </div>
        <div class="col-lg-1 col-sm-3 col-12" style="margin-top: 18px;">
          <div class="form-group">
            <span class="input-group-btn">
              <button class="btn btn-primary" type="button" (click)="exportdata()" ><span class="fa fa-download"></span></button>
            </span>
         </div>

        </div>  
   </div>

   <div *ngIf="datatable==true" class="row">
   <div class="col-lg-12 col-md-12 col-sm-12">
       <!--loader start-->
<div class="loading-div" *ngIf="isLoading">
  <div class="loading-bar">
      <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
      <p class="mt-3">Processing data. Please wait..</p>
  </div>
</div>
  <!--loader end-->
   <table  id="myTable" class="row-border hover" #table>
   <thead>
   <tr >
    <th>S.No</th>
   <th>Year</th>
   <th>Month</th>
   <th>OB</th>
   <th>Addition</th>
   <th>Total</th>
   <th>Deln</th>
   <th>CB</th>
   <th>No.Died During Month</th>
   <th>Percentage of Mortality during Month</th>
   <th>Animal Days</th>
   <th>EADR During the Month</th>
   <th>No.Pregnant Animals</th>
   <th>No.abortions/still births</th>
   <th>Stock Since selected date</th>
   <th>Addition Since selected date</th>
   <th>Total Since selected date </th>
   <th>Deletions Since selected date </th>
   <th>CB</th>
   <th>No.Died Cum Since selected date</th>
   <th>AD Cum Since selected date</th>
   <th>Cummulative EADR</th>
   <th>Cummulative Abortions/Still Births</th>
   </tr>
   </thead>
   <tbody *ngIf="getData.length>0">
   <tr  *ngFor="let reportData of getData;index as j" >
    <td>{{j + 1}}</td>
    <td>{{reportData.year}}</td>
    <td>{{reportData.month}}</td>
    <td>{{reportData.opening_count}}</td>
    <td>{{reportData.addition_count}}</td>
     <td>{{reportData.total_count}}</td>
     <td>{{reportData.deletion_count}}</td>
     <td>{{reportData.current_balance}}</td>
     <td>{{reportData.death_count}}</td>
     <td>{{reportData.mortality_percentage}}</td>
     <td>{{reportData.ani_days }}</td>
     <td>{{show_normal_eadr(reportData.ani_days,reportData.death_count)}}</td>
     <td>0</td>
     <td>0</td>
     <td>{{reportData.cumulative_stock}}</td>
     <td>{{reportData.cumulative_addition}}</td>
     <td>{{reportData.cumulative_total_count}}</td>
     <td>{{reportData.cumulative_deletion}}</td>
     <td>{{reportData.cumulative_current_balance}}</td>
     <td>{{reportData.cumulative_death}}</td>
     <td>{{show_cum_ani_days(j)}}</td>
     <td>{{show_cum_eadr(j,reportData.cumulative_death)}}</td>
     <td>0</td>
   </tr>
   
   </tbody>
   <tbody *ngIf="getData.length==0">
    <tr >
      <td class="center_message" colspan="21">No data found</td>
     </tr>
   </tbody>
   </table>
   </div>
   </div>
</div>
</div>